import React, { useEffect, useState } from 'react'
import Modal from '../../../components/Modal'
import Checkbox from '../../../components/Checkbox';
import { Button } from '../../../components/Button';
import Input from '../../../components/Input';
import Switch from '../../../components/Switch';
import { apiPost, apiPut } from '../../../services/apiServices';
import { endPoints } from '../../../configs/apiUrls';
import { toast } from 'react-toastify';

const CreateProprtyTypeModal = ({
    setShowAddModal,
    isOpen,
    data,
    onPropertyTypeAdded
}: any) => {

    const [newPropertyType, setNewPropertyType] = useState("");
    const [newIsActive, setNewIsActive] = useState(true);
    const [error, setError] = useState("")
    const [showLoader, setShowLoader] = useState(false)


    useEffect(() => {
        setNewPropertyType(data?.propertyType || "")
        setNewIsActive(data?.isActive === false ? false : true)
    }, [data])


    const handleAddPropertyType = async () => {
        if (!newPropertyType.trim()) {
            setError("Please enter property type");
            return;
        }
        setError("");

        try {
            setShowLoader(true);
            const res = data ? await apiPut(`${endPoints.PROPERTY_TYPE}/${data?._id}`, {
                propertyType: newPropertyType,
                isActive: newIsActive

            }) : await apiPost(endPoints.PROPERTY_TYPE, {
                propertyType: newPropertyType,
            })
            if (res?.success) {
                setNewPropertyType("")
                setNewIsActive(true)
                toast.success("Property type created successful!");
                setShowAddModal(false);
                onPropertyTypeAdded()
            } else {
                toast.error(res.data.message || `Failed to ${data ? "update" : "create"} user`);
            }
            setShowLoader(false);
        } catch (error: any) {
            toast.error(error.data.message || `Failed to ${data ? "update" : "create"} user`);
            setShowLoader(false);
        }

    };

    return (
        <Modal isOpen={isOpen} onClose={() => {
            setShowAddModal(false)
            setNewPropertyType("")
            setNewIsActive(true)
        }} title="Add Property Type" size="sm">
            <div>
                <label className="block mb-2 font-medium text-gray-700">
                    Property Type <span className="text-errorText">*</span>
                </label>
                <Input
                    type="text"
                    value={newPropertyType}
                    onChange={(e) => {
                        setNewPropertyType(e.target.value)
                        if (!e.target.value) {
                            setError("Please enter property type")
                        } else {
                            setError("")

                        }
                    }}
                    placeholder="Enter property type"
                    autoFocus
                    label="Property Type"
                    error={error}
                />

                <Switch
                    checked={newIsActive}
                    onCheckedChange={setNewIsActive}
                    label="Active"
                    className={"my-6"}
                />

                <div className="flex justify-end space-x-3">
                    <Button variant="outline" onClick={() => {
                        setShowAddModal(false)
                        setNewPropertyType("")
                        setNewIsActive(true)
                    }}>
                        Cancel
                    </Button>
                    <Button variant="primary" onClick={() => handleAddPropertyType()}>
                        {data ? "Update" : "Add"}
                    </Button>
                </div>
            </div>
        </Modal>
    )
}

export default CreateProprtyTypeModal